


import { defineComponent, onMounted, ref, onBeforeUnmount, computed, onUnmounted } from 'vue';
import { LocalService, MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import ButtonTypeConst from '../../../../domain/Constants/ButtonTypeConst';
import { Container } from 'inversify';
import { ExpresionEngine } from '../../../../../expression/infrastructure/helper/expressionEngine';
import BaseControlTypeConst from '../../../../domain/Constants/BaseControlTypeConst';
import CatalogEventConst from '../../../../../catalog/domain/const/CatalogEventConst';
import CatalogObjectTypeConst from '../../../../../catalog/domain/const/CatalogObjectTypeConst';
import { executeWorkFlow } from '../../../../../workflow/infrastructure/component/rete/rete/editor';
import { useStore } from 'vuex';
import HelperUtils from '../../../../../../../common/infrastructure/funciones/HelperUtils';
import { useRouter } from 'vue-router';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import { Dictionary } from '../../../../../expression/domain/dictionary';
import ToogleButtonTypeConst from '../../../../domain/Constants/ToogleButtonTypeConst';

export default defineComponent({
    name: 'dynamic_toogle_button',
    props:
    {
        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },
    },
    setup(props, context) {
        //
        const store = useStore();
        const router = useRouter();
        const { vmodel,baseOnMounted, isValidData, getPropertyValue, getPropertyBooleanValue, loaded, componentData, resolveExpressions, getCatalogValue, baseOnUnmount,fieldKey,fieldKeyComponentDataSourceId,processEventComponent } = ComponentCommon(props, context,store);


        const clickf = ref(new Function());

        const showMessage = (msg: string) => {
            MessageService.showToast(MessageType.Correcto, '', msg)
        }

       
        onMounted(() => {
            baseOnMounted();
         
        })

        onUnmounted(() => {
            baseOnUnmount();
        })

        return {
            resolveExpressions,
            clickf,
            MessageService,
            MessageType,
            showMessage,
            getPropertyValue,
            getPropertyBooleanValue,
            vmodel,
            ToogleButtonTypeConst,
            BaseControlTypeConst,
            loaded,
            processEventComponent,
            CatalogEventConst,
            getCatalogValue,
            isValidData,
            fieldKey,
            fieldKeyComponentDataSourceId

        };
    },
});
